













































































// Vue
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

// Vuex
import { mapGetters } from 'vuex'
import { namespace } from 'vuex-class'

// models
import { UserLogin } from '@/models'

// utils
import { loading } from '@/utils'

const authStore = namespace('auth')

@Component({
    name: 'HorizontalTopBar',
    computed: {
        ...mapGetters('auth', {
            auth: 'auth'
        })
    }
})
export default class HorizontalTopBar extends Vue {
    @Prop({ type: String, required: true }) readonly type!: string
    @Prop({ type: String, required: true }) readonly width!: string

    auth!: UserLogin

    @authStore.Action
    public logout!: () => true

    // methods
    initFullScreen () {
      document.body.classList.toggle('fullscreen-enable')
      if (
        !document.fullscreenElement &&
        // @ts-ignore
        /* alternative standard method */ !document.mozFullScreenElement &&
        // @ts-ignore
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
          // @ts-ignore
        } else if (document.documentElement.mozRequestFullScreen) {
            // @ts-ignore
          document.documentElement.mozRequestFullScreen()
          // @ts-ignore
        } else if (document.documentElement.webkitRequestFullscreen) {
            // @ts-ignore
          document.documentElement.webkitRequestFullscreen(
              // @ts-ignore
            Element.ALLOW_KEYBOARD_INPUT
          )
        }
      } else {
          // @ts-ignore
        if (document.cancelFullScreen) {
            // @ts-ignore
          document.cancelFullScreen()
          // @ts-ignore
        } else if (document.mozCancelFullScreen) {
            // @ts-ignore
          document.mozCancelFullScreen()
          // @ts-ignore
        } else if (document.webkitCancelFullScreen) {
            // @ts-ignore
          document.webkitCancelFullScreen()
        }
      }
    }

    toggleRightSidebar () {
      this.$emit('toggleRightSidebar')
    }

    toggleMenu () {
      const element = document.getElementById('topnav-menu-content')
      if (element) {
          element.classList.toggle('show')
      }
    }

    async logoutAuth () {
        loading('show')
        await this.logout()
        location.reload()
    }

    // computed
    get layoutOptions () {
        return {
        ...this.$store.state.layout
        }
    }

    // watch
    @Watch('type', { immediate: true, deep: true })
    changeType (newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
            switch (newVal) {
            case 'dark':
                document.body.setAttribute('data-topbar', 'dark')
                break
            case 'light':
                document.body.setAttribute('data-topbar', 'light')
                document.body.removeAttribute('data-layout-size')
                break
            case 'colored':
                document.body.setAttribute('data-topbar', 'colored')
                document.body.removeAttribute('data-layout-size')
                break
            default:
                document.body.setAttribute('data-topbar', 'dark')
                break
            }
        }
    }

    @Watch('width', { immediate: true, deep: true })
    changeWidth (newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed')
              break
            case 'fluid':
              document.body.setAttribute('data-layout-mode', 'fluid')
              document.body.removeAttribute('data-layout-size')
              break
            default:
              document.body.setAttribute('data-layout-mode', 'fluid')
              break
          }
        }
      }
}
